import React, { useState } from 'react';
import Sidebar from "../admin/components/SideBar";
import Header from "../admin/components/Header";

export function AdminLayout(props) {
    const [showMenu, setShowMenu] = useState(1);

    function handleShowMenu() {
        setShowMenu(!showMenu);
    }
 
    return (
        <div className={showMenu ? '' : 'toggle-sidebar'}>
            <Header hsmenu={handleShowMenu} />
            <Sidebar />
            <div>
                {props.children}
            </div>
        </div>
    );
}
